import React from 'react';

interface LogoProps {
  className?: string;
  size?: number;
}

export function HotmartLogo({ className = '', size = 32 }: LogoProps) {
  return (
    <div 
      className={`flex items-center justify-center ${className}`}
      style={{ width: size, height: size }}
    >
      <svg 
        viewBox="0 0 32 32" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        style={{ width: '100%', height: '100%' }}
      >
        <rect width="32" height="32" rx="6" fill="#FF5C00"/>
        <path 
          d="M8 10h4v4h4v-4h4v12h-4v-4h-4v4H8V10z" 
          fill="white"
        />
      </svg>
    </div>
  );
}

export function BraipLogo({ className = '', size = 32 }: LogoProps) {
  return (
    <div 
      className={`flex items-center justify-center ${className}`}
      style={{ width: size, height: size }}
    >
      <svg 
        viewBox="0 0 32 32" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        style={{ width: '100%', height: '100%' }}
      >
        <rect width="32" height="32" rx="6" fill="#00D084"/>
        <path 
          d="M8 10h6c2.2 0 4 1.8 4 4s-1.8 4-4 4h-2v4H8V10zm4 5h2c.6 0 1-.4 1-1s-.4-1-1-1h-2v2z" 
          fill="white"
        />
        <circle cx="21" cy="16" r="5" fill="white" fillOpacity="0.3"/>
        <circle cx="21" cy="16" r="3" fill="white"/>
      </svg>
    </div>
  );
}

export function getPlatformLogo(platformId: string, size: number = 32) {
  if (platformId === 'HO') return <HotmartLogo size={size} />;
  if (platformId === 'BR') return <BraipLogo size={size} />;
  return <HotmartLogo size={size} />;
}
